<template>
	<div class="user-picture">
		<img class="image-container" :src="src"/>	
	</div>
</template>

<script>
export default {
	name: 'user-picture',
	
	props: {
		/* Picture source */
		src: {
			type: String,
			required: true
		}
	}
}
</script>

<style lang="stylus" scoped>
.user-picture
	position relative

	.image-container
		width 100%
		height 100%
		
		position absolute
		top 0
		left 0

		padding inherit
		border-radius 50%
		box-sizing border-box
		
		overflow hidden

		>img
			display block
</style>
